import { Form, Input, Modal } from "antd";
import { useEffect } from "react";
import SingleUpload from "./SingleUpload";

interface ModalMarkPaidProps {
  visible: boolean;
  confirmLoading?: boolean;
  handleClose: (values?: Record<string, any>) => void;
}

const ModalMarkPaid: React.FC<ModalMarkPaidProps> = ({
  visible,
  confirmLoading,
  handleClose,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      form.resetFields();
    }
  }, [visible]);

  const onFinish = (values: Record<string, any>) => {
    handleClose(values);
  };

  return (
    <Modal
      title="Mark as paid"
      open={visible}
      confirmLoading={confirmLoading}
      onCancel={() => handleClose()}
      okText={"Mark paid"}
      onOk={form.submit}
    >
      <Form
        form={form}
        className="ant-advanced-search-form"
        onFinish={onFinish}
        layout="vertical"
      >
        <Form.Item name="remark" label="Remark">
          <Input.TextArea style={{ width: "100%" }} placeholder="remark" />
        </Form.Item>
        <Form.Item name="payment_receipt" label="Payment receipt">
          <SingleUpload />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalMarkPaid;
